import { baseUrl as groupBaseUrl } from './groups';
import { baseUrl as productBaseUrl } from './products';

export const ApiCenters = {
  GetCenterDetail: (centerId: string) => `${groupBaseUrl}/v2/${centerId}`,
  GetListCenterByProduct: (productId: string) => `${productBaseUrl}/${productId}/centers/list`
};
